import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';

@Component({
    selector: 'app-report-delete',
    templateUrl: './report-delete.component.html',
    styleUrls: ['./report-delete.component.scss'],
    standalone: false
})
export class ReportDeleteComponent implements OnInit {
  translate: any;

  constructor(
      public modalRef : BsModalRef, 
      private modalService: BsModalService,
      private languageTranslateService: LanguageTranslateService
  ) { }

  ngOnInit(): void {
    this.languageTranslateService.wordSrc$.subscribe(transData => {
      if (Object.keys(transData).length != 0) {
        this.translate = transData;
      }
    })
  }

  onSaveReport(){
   this.modalService.setDismissReason('save');
   this.modalRef.hide();
  }

  onDiscardReport(){
    this.modalService.setDismissReason('discard');
    this.modalRef.hide();
  }

}
